<template>
  <div class="ad-tree__wrapper">
    <div class="ad-tree__market">
      <gj-market-select
          ref="marketSelect"
          :value="marketId"
          init-value
          :clearable="false"
          @input="marketChange($event)"
          width="130px"
      ></gj-market-select>
      <div class="ad-tree--time">
        <gj-local-time :label="localCountry" :time="localTime"></gj-local-time>
      </div>
    </div>
    <el-row
        type="flex"
        align="middle"
        justify="space-between"
        class="ad-tree__header">
      <div class="ad-tree__header--title">广告组合</div>
      <div>
        <gj-button
            v-if="$permission('adsSpCampaigns:addOrUpdate') && adStore.SP.isAdsAuth"
            type="text"
            class="ad-tree__header--op"
            @click="addPortfolio">
          <i class="el-icon-plus" style="font-weight: bold;"></i>
        </gj-button>
      </div>
    </el-row>
    <div class="ad-tree__body">
      <el-row type="flex" class="ad-tree__home" v-gutter="10">
        <gj-button
            type="icon"
            style="font-size: 18px;"
            @click="goHome()">
          <gj-icon iconfont="iconicon_home"></gj-icon>
        </gj-button>
        <div class="ad-switch">
          <span class="switch-cell" :class="{active: adSwitch == '0'}" @click="adSwitchChange('0')">广告活动</span>
          <span class="switch-cell" :class="{active: adSwitch == '1'}" @click="adSwitchChange('1')">广告组合</span>
        </div>
      </el-row>
      <el-row class="search">
        <gj-input
            v-model="searchText"
            maxlength="80"
            :placeholder="adSwitch == '0' ? '搜索广告活动': '搜索广告组合'"
            width="200px">
          <template #append>
            <i class="el-input__icon el-icon-search"></i>
          </template>
        </gj-input>
      </el-row>
      <el-row v-if="adSwitch == '0'" class="tree-content">
        <el-tree
          accordion
          ref="tree"
          node-key="campaignId"
          v-loading="treeLoading"
          :expand-on-click-node="false"
          :data="aDtreeData"
          :filter-node-method="filterNode"
          :default-expanded-keys="['已启用']">
          <div class="custom-tree-node" slot-scope="{ data }">
            <!-- 状态  -->
            <div class="tree-title" v-if="data.adsLever == 0">
              <span>{{ data.stateName }}</span>
            </div>
            <!-- 广告活动  -->
            <div class="tree-cell" :class="{'active-click': (adStore.SB.campaign && !adStore.SB.group && data.campaignId == adStore.SB.campaign.campaignId)}" @click="routeClick(data)" v-else-if="data.adsLever == 2">
              <span class="status-title" :class="`status${data.state}`"></span>
              <span class="status-main" :title="data.campaignName">{{ data.campaignName }}</span>
              <div class="new-page">
                <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SB"
                  :campaign="data">
                  <gj-tooltip content="新标签页打开" >
                    <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                  </gj-tooltip>
                </app-ad-route-link>
              </div>
            </div>
          </div>
        </el-tree>
      </el-row>
      <el-row v-if="adSwitch == '1'" class="tree-content">
        <el-tree
          accordion
          ref="tree"
          node-key="campaignId"
          v-loading="treeLoading1"
          :expand-on-click-node="false"
          :data="aDtreeData1"
          :filter-node-method="filterNode"
          :default-expanded-keys="['已启用']">
          <div class="custom-tree-node" slot-scope="{ data }">
            <!-- 广告组合  -->
            <div class="tree-cell" :class="{'active-click': portfolioId == data.portfolioId}" @click="portfolioChange(data.portfolioId)" v-if="data.adsLever == 1">
              <span :title="data.portfolioName">{{ data.portfolioName }}</span>
            </div>
            <!-- 广告活动  -->
            <div class="tree-cell" :class="{'active-click': (!adStore.SB.group && adStore.SB.campaign && data.campaignId == adStore.SB.campaign.campaignId)}" @click="routeClick(data)" v-else-if="data.adsLever == 2">
              <span class="status-title" :class="`status${data.state}`"></span>
              <span class="status-main" :title="data.campaignName">{{ data.campaignName }}</span>
              <div class="new-page">
                <app-ad-route-link
                  :market-id="marketId"
                  :type="AdTypeEnum.SB"
                  :campaign="data">
                  <gj-tooltip content="新标签页打开" >
                    <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                  </gj-tooltip>
                </app-ad-route-link>
              </div>
            </div>
          </div>
        </el-tree>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { isMeaningful, queryParamsMap } from "@/utils/common";
  import { adStore } from "modules/ad/common/store";
  import { getMarket } from "@/api/common";
  import { optionText } from "@/filters";
  import { countryOption } from "@/utils/options";
  import AppAddPortfolioModal from "modules/ad/common/components/add-portfolio-modal";
  import {Portfolios, campaignGrouping, SBDisplay} from "@/api/ad";
  import { AdTypeEnum } from "modules/ad/common/enum";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";

  export default {
    name: "app-sb-ad-tree",
    inject: ['removeTabList', 'getNavTabs'],
    components: { AppAdRouteLink },
    props: {
      initMarketId: {
        required: false
      }
    },
    watch: {
      searchText(val) {
        this.treeFilter(this, val)
      }
    },
    created() {
      if (isMeaningful(this.initMarketId)) {
        this.marketChange(this.initMarketId);
      }
    },
    data() {
      return {
        adStore,
        AdTypeEnum,
        marketId: null,
        portfolioId: null,
        localTime: null,
        treeLoading: false,
        treeLoading1: false,
        localCountry: '',
        searchText: '',
        adSwitch: '0', // 0:广告活动; 1:广告组
        treeStatus: ["已启用", "已停用", "已归档"],
        aDtreeData: [], // 广告活动树数据
      }
    },
    methods: {
      // 树结构过滤
      treeFilter: _.debounce(((vm, val) => {
        // vm.$refs.tree.filter(val);
        if(vm.adSwitch == '0') {
          vm.aDtreeDataInit(vm.marketId, val)
        } else {
          vm.aDtreeData1Init(vm.marketId, val)
        }
      }), 300),
      // 添加广告组合
      addPortfolio() {
        const vm = this;
        this.$gjCreate(AppAddPortfolioModal, {
          mountTo: document.getElementById('gj-base-main'),
          props: {
            marketId: this.marketId,
          },
          on: {
            created() {
              vm.getPortfolio();
              vm.aDtreeDataInit(vm.marketId)
              vm.aDtreeData1Init(vm.marketId)
            }
          }
        });
      },
      // 判断是否有品牌
      async SBDisplay(marketId) {
        this.adStore.SB.isBrand = -1;// 正在校验
        try {
          let { data } = await SBDisplay({marketId})
          this.adStore.SB.isBrand = data;// 站点是否有品牌 -1：正在校验 0:无品牌无数据 1：有品牌 2：无品牌有数据
        } catch (error) {
          this.adStore.SB.isBrand = 0
        }
      },
      // 广告活动树过滤
      filterNode(value, data) {
        if (!value) return true
        let valueMap = value.toLowerCase()
        if (data.adsLever == 0) {
          return true
        }else if(data.adsLever == 1) {
          return data.portfolioName && data.portfolioName.toLowerCase().indexOf(valueMap) !== -1;
        }else if(data.adsLever == 2) {
          return data.campaignName && data.campaignName.toLowerCase().indexOf(valueMap) !== -1;
        }else if(data.adsLever == 3) {
          return data.groupName && data.groupName.toLowerCase().indexOf(valueMap) !== -1;
        }
      },
      // 初始化广告活动树结构
      async aDtreeDataInit(marketId, campaignName = '') {
        if (!marketId) return false
        this.treeLoading = true
        try {
          let { data = [] } = await campaignGrouping({marketId, campaignName})
          data.forEach(item => {
            item.campaignId = item.stateName
            item.campaignName = item.stateName
          })
          this.aDtreeData = data
        } finally {
          this.treeLoading = false
        }
      },
      // 初始化广告组合树结构
      async aDtreeData1Init(marketId, portfolioName = '') {
        if (!marketId) return false
        this.treeLoading1 = true
        try {
          let { data = [] } = await campaignGrouping({marketId, queryType: 1, portfolioName})
          data.forEach(item => {
            item.campaignId = item.stateName
            item.campaignName = item.stateName
          })
          this.aDtreeData1 = data
        } finally {
          this.treeLoading1 = false
        }
      },
      // 点击广告活动
      routeClick(data) {
        if (!this.$permission('adsSbCampaigns:update')) {
          return false
        }
        this.portfolioChange(null);
        adStore.SB.campaign = data;
        adStore.SB.group = null;
      },
      // 回到首页
      goHome() {
        adStore.SB.campaign = null;
        this.portfolioChange(null);
        this.searchText = "";
        this.adSwitch = '0';
        this.$emit("goHome")
      },
      marketChange(marketId, activeTab = null) {
        if (marketId !== this.marketId) {
          this.adSwitchChange('0')
          this.getPortfolio(marketId);
          this.aDtreeDataInit(marketId)
          this.aDtreeData1Init(marketId)
          this.getMarket(marketId);
          this.marketId = marketId;
          this.portfolioChange(null);
          this.$emit('market-change', this.marketId);
        }
      },
      portfolioChange(portfolioId) {
        if (this.portfolioId !== portfolioId) {
          this.portfolioId = portfolioId;
        } else {
          this.portfolioId = null;
        }
        this.$emit('portfolio-change', this.portfolioId);
      },
      getMarket(marketId) {
        return getMarket(marketId)
          .then((market) => {
            adStore.SB.market = market;
            adStore.SB.marketId = marketId;
            adStore.SB.currencySymbol = market.currencySymbol;
            adStore.SB.isAdsAuth = market.isAdsAuth;
            this.localTime = market.datetime;
            this.localCountry = optionText(market.countryCode, countryOption);
            this.$emit("getLocal", this.localTime, this.localCountry)
            if (market.isAdsAuth) {
              this.SBDisplay(marketId);
            }
          })
      },
      getPortfolio(marketId) {
        // 查询广告组合
        this.treeLoading = true;
        Portfolios.getPortfolios({marketId: marketId || this.marketId})
          .then(({data}) => {
            adStore.SB.portfolios = data;
          })
          .complete(() => {
            this.treeLoading = false;
          });
      },
      routeTo(marketId, activeTab) {
        this.$router.push(`/ad/sb-ad/ad-manager?${queryParamsMap({
            marketId,
            portfolioId: this.portfolioId,
            activeTab,
          })}`,
          onComplete => {},
          onAbort => {}
        );
      },
      // 改变
      adSwitchChange(type) {
        this.adSwitch = type
        this.searchText = ""
      }
    }
  }
</script>

<style scoped lang="scss">
  .ccc {
    color: #999;
    cursor: auto;
  }
  .search {
    padding: 10px 10px 10px 12px;
    /deep/.el-input__inner {
        border-bottom-width: 1px;
        border-radius: 0;
        padding-left: 12px;
        padding-right: 50px;
    }
    /deep/.el-input-group__append {
        border: 0;
        background: #fff;
        position: absolute;
        top: 2px;
        right: 2px;
        padding: 0;
        width: 0;
        height: 80%;
    }
    /deep/.el-input__suffix {
      transform: translateX(-20px) !important;
    }
  }
  .el-icon-search {
    cursor: pointer;
  }
  /deep/.el-tree-node__expand-icon {
    font-size: 15px;
  }
  /deep/.el-tree-node__content {
    height: 30px;
  }
  /deep/.el-icon-caret-right {
    color: #999;
    &.el-tree-node__expand-icon.is-leaf {
      color: transparent;
    }
  }
  .tree-content {
    height: calc(100vh - 316px);
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 12px;
    color: #666;
    &::-webkit-scrollbar-track { 
      background: #fff;
    }
    .custom-tree-node {
      width: 80%;
      line-height: 30px;
      .tree-cell {
        color: #666;
        .status-main {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 150px;
          line-height: 1;
        }
        .new-page {
            display: none;
          }
        &:hover {
          .status-main {
            max-width: 135px;
          }
          .new-page {
            display: inline-block;
          }
        }
      }
      .tree-title {
        display: flex;
        align-items: center;
        color: #000;
        font-weight: 500;
      }
      .status-title {
        width: 6px;
        height: 6px;
        border-radius: 100%;
        margin-right: 2px;
        display: inline-block;
        background: #999;
        transform: translateY(-1px);
        &.status0 {
          background: #1F6EEF;
        }
        &.status1 {
          background: #ddd;
        }
      }
      .active-click {
        color: #1F6EEF;
      }
    }
  }
  .ad-tree__market {
    padding: 5px 10px 15px;
    border-bottom: 1px solid #EBEEF5;
    position: relative;
  }
  .ad-tree--time {
    color: #333;
    font-size: 12px;
  }
  .ad-tree__header {
    padding: 0 10px;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
    height: 40px;
    box-sizing: border-box;
  }
  .ad-tree__header--title {
    color: #666666;
    font-weight: 700;
  }
  .ad-tree__header--op {
    font-size: 14px;
    padding: 0;
    color: #999;
  }
  .ad-tree__body {
    padding: 10px 0 0 0;
    .ad-switch {
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .switch-cell {
        position: relative;
        width: 78px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        // background: #EDF7FF;
        // border-radius: 2002px;
        border: 1px solid #D8DADD;
        cursor: pointer;
        color: #666;
        &:first-child {
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
        }
        &:last-child {
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
        &.active {
          z-index: 2;
          color: #1F6EEF;
          border: 1px solid #1F6EEF;
          background: #EDF7FF;
        }
      }
    }
  }
  .ad-tree__home {
    padding: 0 12px 10px;
    border-bottom: 1px solid #EBEEF5;
  }
  
  .ad-tree__market /deep/ .el-select input  {
    border: none;
    padding: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .ad-tree__market{
    /deep/ .el-input__inner{
      &:focus{
        box-shadow: none;
      }
    }
  }
  
  .ad-tree__market /deep/ .el-select .el-input .el-input__suffix {
    right: -22px;
    background: #fff;
  }
  
  .ad-tree__market /deep/ .el-select .el-input .el-select__caret {
    color: #999;
    font-weight: bold;
  }

  .ad-tree-node__content {
    height: 30px;
    cursor: pointer;
    font-size: 12px;
    padding: 0 10px;
    box-sizing: border-box;
    color: #606266;
  }

  .ad-tree-node__content:hover {
    background-color: #F5F7FA;
  }
  .ad-tree-node__content.active {
    color: #1F6EEF;
    background-color: #EDF7FF;
  }
</style>
